export default __webpack_public_path__ + "static/media/items_shw02.4d17a7ff.jpg";